export function toScreenPosition(position = new Vector3(), camera, width, height) {
  const p = position.clone()
  const vector = p.project(camera)

  vector.x = (vector.x + 1) / 2 * width
  vector.y = -(vector.y - 1) / 2 * height

  return vector
}